import React from 'react'

export const cloneElementArray = (elements, props) => {
  if (elements && !elements.length) {
    elements = [elements]
  }

  return (
    elements &&
    elements.filter(ele => ele).map((child, index) =>
      React.cloneElement(child, {
        ...props,
        key: index,
      }),
    )
  )
}

export const pure = fn => (effects, ...args) => state => (
  fn(effects, state, ...args), // eslint-disable-line
  state
)



// WEBPACK FOOTER //
// ./src/utils.js